import { useRouter } from 'next/router';
import { useContext, useState } from 'react';
import { HamburgerMenu } from 'src/components/shared/templates/header/HamburgerMenu';
import { HeaderRight } from 'src/components/shared/templates/header/HeaderRight';
import { Navi } from 'src/components/shared/templates/header/Navi';
import { SearchInput } from 'src/components/shared/templates/header/SearchInput';
import { WaWebRoutes } from 'src/config/routes';
import { useCustomHeaderLogo } from 'src/hooks/useCustomHeaderLogo';
import { useModal } from 'src/hooks/useModal';
import { useResponsive } from 'src/hooks/useResponsive';
import { UserService } from 'src/libs/wa/services/UserService';
import { AuthContext } from 'src/stores/Auth';
import { I18nContext } from 'src/stores/I18n';
import { shouldBeTreatedAsH1 } from 'src/utils/makeLogoH1ByUrl';
import { mixpanel } from 'src/utils/mixpanel';
import type { HeaderProps } from 'wamazing-UI-components-react/src/components/header';
import { Header as WAheader } from 'wamazing-UI-components-react/src/components/header';
import type { LanguagesType } from 'wamazing-UI-components-react/src/models/languagesType';
import { AppLeadingBanner } from '../AppLeadingBanner';

export const Header: React.FC = () => {
  const { locale } = useRouter();
  const localeResources = useContext(I18nContext);
  const { user } = useContext(AuthContext);
  const { setIsVisible, setModalParams } = useModal('noticeModal');
  const { pathname } = useRouter();
  const [isCategoryActive, setIsCategoryActive] = useState(false);

  const signOut = async () => {
    await new UserService().signOut();
    mixpanel.onUserSignOut();
    setModalParams({
      type: 'info',
      title: localeResources.auth.signedOut,
      text: localeResources.auth.lookForwardToServingYouAgain
    });
    setIsVisible(true);
    setTimeout(() => {
      window.location.pathname = process.env.NEXT_PUBLIC_TOP_PATH;
    }, 1500);
  };

  const userMenuItems = [
    {
      title: localeResources.mypage.title,
      link: `${WaWebRoutes.account.me.mypage}?redirect_url=${encodeURIComponent(window.location.href)}`
    },
    {
      title: localeResources.coupons.coupon,
      link: `${WaWebRoutes.account.me.coupons}?redirect_url=${encodeURIComponent(window.location.href)}`
    },
    {
      title: localeResources.favorites.title,
      link: '/kaimono/favorites'
    },
    {
      title: localeResources.auth.creditCardList,
      link: `${WaWebRoutes.account.me.payment}?redirect_url=${encodeURIComponent(window.location.href)}`
    },
    {
      title: localeResources.customerSupport.title,
      link: '/kaimono/support'
    }
  ];

  const { isTablet } = useResponsive();
  const customLogo = useCustomHeaderLogo();

  const freeContent = {
    center: <SearchInput showIconOnly={!isTablet && !!customLogo} />,
    right: <HeaderRight />
  };

  const headerProps: HeaderProps = {
    lang: locale as LanguagesType,
    productName: 'kaimono',
    user: user,
    menu: userMenuItems,
    content: freeContent,
    logout: signOut,
    isH1Logo: shouldBeTreatedAsH1(pathname),
    logo: customLogo,
    kaimonoMenuComponent: <HamburgerMenu onCategoryActiveChange={setIsCategoryActive} />,
    isShowAllServices: !isCategoryActive && locale !== 'zh_cn',
    logoStyle: customLogo && {
      minWidth: '195px',
      display: 'flex',
      flexShrink: 0
    }
  };

  return (
    <>
      <WAheader {...headerProps} />
      <AppLeadingBanner />
      <Navi />
    </>
  );
};
